import styled, { css } from 'styled-components';

export const Content = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-template-columns: 100%;
    grid-gap: ${spacing.km6};
    height: 13.25rem;
    overflow-y: scroll;
    padding-right: ${spacing.km4};
  `}
`;
